export default __webpack_public_path__ + "static/media/Confetti.bb7ecc60.gif";